import {useCallback} from "react";
import {useSearchParams} from "react-router-dom";

export function useQueryPatch() {
    const [, setSearchParams] = useSearchParams();

    const patchParams = useCallback(
        (
            patch: Record<string, string | null | undefined>,
            opts?: { resetPage?: boolean; replace?: boolean }
        ) => {
            setSearchParams(
                (prev) => {
                    const p = new URLSearchParams(prev);

                    for (const [k, v] of Object.entries(patch)) {
                        if (v === null || v === undefined || v === "") p.delete(k);
                        else p.set(k, v);
                    }

                    if (opts?.resetPage) p.set("page", "1");
                    return p;
                },
                {replace: opts?.replace ?? true}
            );
        },
        [setSearchParams]
    );

    return {patchParams};
}
